import React from 'react';
import cs from 'classnames';

import authPageCSS from '~/components/authpage.css';

const ErrorBlock = (props) => {
  if (!props.children) {
    return null;
  }

  if (props.wrap) {
    const Wrap = props.wrap;
    return <Wrap>{props.children}</Wrap>;
  }

  return (<div className={cs(authPageCSS.error, 'qa-error-message')}>
    {props.children}
  </div>);
};

export default ErrorBlock;



// WEBPACK FOOTER //
// ./src/components/user/Error/index.js